export default {
    REJECTED: 'REJECTED',
    SUBMITTED: 'SUBMITTED',
    PERSISTENT: 'PERSISTENT',
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    OFFLINE: 'offline',
    ONLINE: 'online'
}